import React, { useEffect } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter as Router } from 'connected-react-router';
import * as Tooltip from '@radix-ui/react-tooltip';
import { ApolloProvider, useQuery } from '@apollo/client';
import { store, history } from '~/store';
import { FeaturesWrapper } from '@bufferapp/features';

import './components/i18n';
import App from './components/App';
import getErrorBoundary from './components/ErrorBoundary';
import { client } from '../apollo-client';
import { AccountContext, GET_ACCOUNT } from '../accountContext';
import GlobalStyles from '../global-styles/globalStyles';

function getQueryParams() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  return params;
}

store.dispatch({
  type: 'APP_INIT',
  queryParams: getQueryParams(),
});

const ErrorBoundary = getErrorBoundary();

const Publish = () => {
  const {
    loading,
    data: account,
    refetch: refetchAccount,
  } = useQuery(GET_ACCOUNT);

  useEffect(() => {
    const { ORGANIZATION_EVENT_KEY } = window?.appshell?.eventKeys || {};
    const { billingUpdated } = window?.appshell?.actionKeys || {};

    function onOrgChange({ detail }) {
      if (!detail.action) {
        refetchAccount();
      } else if (detail.action === billingUpdated) {
        refetchAccount();
        store.dispatch({ type: 'INIT_ORGANIZATIONS' });
      }
    }
    window.addEventListener(ORGANIZATION_EVENT_KEY, onOrgChange);

    return function cleanup() {
      window.removeEventListener(ORGANIZATION_EVENT_KEY, onOrgChange);
    };
  }, [window?.appshell]);

  const getEnvironment = (env) =>
    ({
      development: 'local',
      staging: 'staging',
      production: 'production',
    }[env]);
  const environment =
    getEnvironment(process.env.NODE_ENV) || getEnvironment('production');

  return (
    <ErrorBoundary>
      <FeaturesWrapper environment={environment}>
        <AccountContext.Provider value={{ ...account, loading }}>
          <Provider store={store}>
            <Router history={history}>
              <React.Suspense fallback={<div>Loading...</div>}>
                <Tooltip.Provider>
                  <App />
                </Tooltip.Provider>
              </React.Suspense>
            </Router>
          </Provider>
        </AccountContext.Provider>
      </FeaturesWrapper>
    </ErrorBoundary>
  );
};

render(
  <ApolloProvider client={client}>
    <GlobalStyles />
    <Publish />
  </ApolloProvider>,
  document.getElementById('root')
);
